<template>
    <div class="template-container">
        <CustomDialog :title="title" @close="cancel" :visible.sync="dialogShow" width="860px" append-to-body
            @save="comboSave">
            <div slot="content" class="template-warp">
                <div class="select-warp">
                    <div class="flex-sh"> <span class="colorF54A">*</span> 归属医生：</div>
                    <el-select class="w100_" :disabled="comboTypeAction == 'edit'" filterable
                        v-model="editRecipeForm.doctorId" placeholder="请选择">
                        <el-option v-for="item in doctorList" :key="item.doctorId" :label="item.doctorName"
                            :value="item.doctorId">
                        </el-option>
                    </el-select>
                </div>
                <!-- 病例模块 -->
                <div class="case-warp">
                    <div class="case-title font600 size15">模版信息</div>
                    <div class="case-item">
                        <div class="case-item-title"><span class="colorF54A">*</span>名称</div>
                        <el-input :class="{ 'isInvalid': isInputInvalid }" type="text" class="item-textarea"
                            v-model="editRecipeForm.comboName" />
                    </div>
                </div>
                <div class="prescription-warp">
                    <div class="prescription-top">
                        <div class="display-f align-i-c">
                            <div>处方明细</div>
                            <div class="drug-type">
                                <div>类型：</div>
                                <el-select @change="typeChange($event)" ref="select" class="type-select"
                                    v-model="editRecipeForm.drugForm" placeholder="">
                                    <el-option v-for="obj in recipeList" :disabled="obj.disabled" :key="obj.value" :label="obj.label"
                                        :value="obj.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div>加工费：每剂<el-input class="processFee-input" v-model="editRecipeForm.processFee"
                                @input="processFeeChange"></el-input>元</div>
                    </div>
                    <div class="drug-list">
                        <el-row>
                            <vuedraggable :options="dragOptions" forceFallback="true" fallbackClass="fallbackClass"
                                v-model="editRecipeForm.items">
                                <el-col :span="6"
                                    :class="drugIndex == editRecipeForm.items.length - 1 ? '' : 'drugItem'"
                                    v-for="(kid, drugIndex) in editRecipeForm.items" :key="kid.spuId">
                                    <div class="drug-search" @mouseenter="enterKid(kid)" @mouseleave="leaveKid(kid)">
                                        <div class="drag-warp">
                                            <img class="drag-icon" :src="imgArr.dragIcon" />
                                        </div>
                                        <div class="search-top">
                                            <el-popover :ref="'popover' + drugIndex" placement="bottom" trigger="click"
                                                popper-class="search-popper">
                                                <el-input :ref="'search' + drugIndex" slot="reference"
                                                    class="input-search" type="text" autocomplete="off"
                                                    spellcheck="false" maxlength="30" v-model="kid.drugName"
                                                    placeholder="药名" @focus="focusIndex = 0"
                                                    @blur="drugSearchBlur(drugIndex)"
                                                    @input="getDrugList(kid.drugName, editRecipeForm.drugForm, drugIndex)"
                                                    @keydown.left.native.prevent="numberInputMove($event, 'left', drugIndex)"
                                                    @keydown.right.native.prevent="numberInputMove($event, 'right', drugIndex)"
                                                    @keydown.enter.native="setDrug(kid.drugName, drugIndex)"
                                                    @keydown.down.native="numberInputMove($event, 'down', drugIndex)"
                                                    @keydown.up.native="numberInputMove($event, 'up', drugIndex)"></el-input>
                                                <div class="customTable">
                                                    <customTable :highlight-current-row="true"
                                                        :ref="'customTable' + drugIndex"
                                                        @row-click="rowClick($event, drugIndex)"
                                                        :header-cell-style="{ background: '#F5F9FF' }" :column="column"
                                                        :tableData="drugList" :showPages="false" height="250">
                                                    </customTable>
                                                </div>
                                            </el-popover>

                                            <div style="flex-shrink: 0;flex-grow:0;">
                                                <el-input :ref="'dosage' + drugIndex" class="input-dosage" type="text"
                                                    autocomplete="off" spellcheck="false" maxlength="6"
                                                    v-model="kid.number" placeholder="用量"
                                                    @input="formatNum($event, kid)" @focus="dosageFocus(drugIndex)"
                                                    @keydown.left.native.prevent="numberInputMove($event, 'left', drugIndex)"
                                                    @keydown.right.native.prevent="numberInputMove($event, 'right', drugIndex)"
                                                    @keydown.enter.native="searchFocus(drugIndex)"></el-input>
                                                <span>{{ kid.unit }}</span>
                                            </div>
                                        </div>
                                        <div class="usage-warp">
                                            <SelectPanel :ref="'operate' + drugIndex"
                                            :class="{ prescription_decoction: true, prescription_decoction_hide: [null, undefined, ''].includes(kid.handling), prescription_decoction_hide_most: [null, undefined, ''].includes(kid.spuId) }"
                                            v-model="kid.handling" width="100%" placeholder="煎法" :columnsNum="4" :maxlength="20"
                                            :options="handlingOptions" @focus="decoctionFocus(kid)" :isOwned="kid.isOwned"
                                            @input="chooseUsage($event, drugIndex)"
                                            @enter="operateEnterFn({ drugIndex })" :disabled="!kid.spuId">
                                            <template slot="footer">
                                                <div class="prescription_decoction_footer">
                                                    <div class="decoction_btn" ></div>
                                                    <div class="decoction_btn" @click="rememberDecoction(kid)">
                                                        <span class="decoction_btn_text">记住煎法</span>
                                                        <img class="decoction_btn_icon"
                                                            :src="kid.rememberDecoction === true ? starImgMap.starOn : starImgMap.starOff" />
                                                    </div>
                                                </div>
                                            </template>
                                        </SelectPanel>
                                        </div>
                                        <i class="el-icon-close" style="font-size: 16px; color:#a7aaae"
                                            v-if="kid.deleteShow && editRecipeForm.items.length != 1 && editRecipeForm.items.length != drugIndex + 1"
                                            @click="removeDrug(drugIndex)"></i>
                                    </div>
                                </el-col>
                            </vuedraggable>
                        </el-row>
                    </div>
                    <div class="drug-tips">
                        <div class="doseNumber">
                            <el-input maxlength="3" type="text" v-model="editRecipeForm.quantity" @input="doseNumChange"
                                style=" width: 40px;"></el-input>
                            <span>剂</span>
                        </div>
                    </div>
                </div>
            </div>
        </CustomDialog>
    </div>
</template>

<script>
import CustomDialog from '@/components/customDialog/CustomDialog'
import { DRUG_TYPE, handlingOptions, frequencyOptions, ybCenterDrugDirectoryCategorySignList,ybPropertyList } from '@/utils/const'
import { queryDrugSpu, drugTypeConvert } from "@/api/drug"; // 药品请求
import vuedraggable from 'vuedraggable'; // 拖拽组件
import { deepClone, debounce, isNull, dictText, msgboxWarning, validParams ,isEmptyArray} from '@/utils/validateBase';
import customTable from '@/components/customTable/customTable'
import { Utils } from '@/utils/utils';
import { CommonDTO, doctorDTO, comboDTO } from '@/DTO/index'
import { imgArr } from '@/assets/images/img'
import { positiveNum } from '@/utils/regexp'
import { Outpatient } from '@/views/DoctorWorkstation/newDiagnosis/data/index'
import SelectPanel from '@/components/SelectPanel.vue'
export default {
    // 定义引入的组件
    components: { CustomDialog, vuedraggable, customTable ,SelectPanel},
    props: {
        title: {
            type: String,
            default: '新增处方'
        },
        dialogShow: {
            type: Boolean,
            default: false
        },
        activeComboId: {
            type: String | Number,
            default: ''
        },
        activeDoctorId: {
            type: String | Number,
            default: ''
        },
        form: {
            type: Object,
            default: {}

        },
        comboTypeAction: {
            type: String,
            default: ''
        }
    },
    computed: {

    },
    data() {
        return {
            starImgMap: {
                starOn: require('@/assets/images/star_on.png'),
                starOff: require('@/assets/images/star_off.png')
            },
            imgArr: imgArr,
            editRecipeForm: {},
            doctorList: [], // 处方类别列表
            isInputInvalid: false,//必填项校验
            recipeList: DRUG_TYPE,//药品类别列表
            dragOptions: {
                animation: 200,
                draggable: '.drugItem',
                handle: '.drag-warp'
                // filter:'usage- warp'
            },
            handlingOptions: handlingOptions,
            drugList: [],//药品列表
            column: [
                { label: "商品名称", prop: "spuCommonName", align: 'left',width: '200' },
                { label: "类型", prop: "firstCategoryName", align: 'left', width: '90', },
                { label: "单位", prop: "unit", width: '50' },
                { label: "零售价", prop: "price" },
                { label: "规格", prop: "specifications", width: '120' },
                {
                  label: "医保属性", width: '80', prop: "medicalInsuranceType", formatter: (row => {
                      return isNull(row.medicalInsuranceType) ? '-' : dictText(row.medicalInsuranceType, ybPropertyList)
                  })
                },
            ],//表头
            drugIndex: -1,
            focusIndex: 0,//药品搜索框里输入框聚焦的索引  0药品 1用量
            deptIdList: [],
        }
    },
    //变量监听
    watch: {

    },
    // 页面初始化
    created() {
        this.editRecipeForm = deepClone(this.form)
        if (this.comboTypeAction == 'edit') {
            this.editRecipeForm.items.forEach(item => {
                item.oldDrugName = item.drugName
            })
            this.addSearch(this.editRecipeForm.items)
        }
        this.getDeptList()
        this.getDoctorList()
    },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
        /**
         * 获取全部医馆
         */
        async getDeptList() {
            CommonDTO.getDeptListDTO().then(res => {
                this.deptIdList = res
            })
        },

        /**
         * 取消
         */
        cancel() {
            this.$emit('templateCancel')
        },
        // 获取医生列表
        async getDoctorList() {
            let { total, rows, code } = await doctorDTO.getDoctorList();
            if (code == 200) {
                this.doctorList = isNull(rows) ? [] : rows;
            }
        },
        /**
     * 药品类型一键转换
     * @param {*} obj 
     */
        typeChange(e, item, index) {
            console.log(item, 99999);
            let pre = this.$refs.select.value
            if (Utils.gt(this.editRecipeForm.items.length, 1)) {
                let typeStr = e == '0' ? '中药饮片' : e == '1' ? '中药颗粒' : ''
                if(e=='2') return;
                msgboxWarning(this, {
                    message: `是否将处方中的所有药品转为${typeStr == '' ? '全部' : typeStr}`,
                    confirmFn: async () => {
                        this.editRecipeForm.drugForm = e
                        this.editRecipeForm.items.pop()
                        let { code, data } = await drugTypeConvert({ targetType: e, srcType: pre, drugList: this.editRecipeForm.items })
                        if (code == 200) {
                          this.editRecipeForm.items.forEach(v1 => {
                            data.unmatchDrugList && data.unmatchDrugList.forEach((v2, index) => {
                              if (v1.spuId == v2.spuId) {
                                v1.onSale = '0'
                                v1.firstCategory = e
                              }
                            })
                          })
                          this.editRecipeForm.items.forEach(v1 => {
                            data.newDrugList && data.newDrugList.forEach(v2 => {
                              if (v1.spuId == v2.srcSpuId) {
                                v1.firstCategory = v2.firstCategory,
                                v1.spuCommonName = v2.spuCommonName,
                                v1.unit = v2.unit,
                                v1.drugName = v2.spuCommonName,
                                v1.spuId = v2.spuId
                                v1.itemId = v2.spuId
                                v1.onSale = '1'
                              }
                            })
                          })
                          if (!isEmptyArray(data.unmatchDrugList)) {
                            this.$message.error('未找到对应类型的药品，请更换药品')
                          }
                          this.addSearch(this.editRecipeForm.items);
                        }
                    },
                    cancelFn: () => {
                        this.editRecipeForm.drugForm = pre
                    },
                });
            }
        },
        enterKid(kid) {
            this.$set(kid, 'deleteShow', true);
            this.$forceUpdate();
        },
        leaveKid(kid) {
            this.$set(kid, 'deleteShow', false);
            this.$forceUpdate();
        },
        /**
         * 药品输入框失去焦点
         */
        drugSearchBlur(drugIndex) {
            let items = deepClone(this.editRecipeForm.items)
            items[drugIndex].drugName = items[drugIndex].oldDrugName
            this.drugIndex = -1
            this.editRecipeForm.items = items
        },
        /**
         * 请求药品列表
         * val 药品名字
         * type 药品类型
         */
        getDrugList: debounce(function (val, type, drugIndex) {
            let typeStr = ''
            switch (type) {
                case '0':
                    typeStr = '中药饮片';
                    break;
                case '1':
                    typeStr = '中药颗粒';
                    break;
                case '2':
                    typeStr = null;
                    break;
            }
            if (isNull(val)) {
                this.editRecipeForm.items[drugIndex].spuId = null;
                this.editRecipeForm.items[drugIndex].drugName = '';
                this.editRecipeForm.items[drugIndex].number = '';
                this.editRecipeForm.items[drugIndex].oldDrugName = '';
                return;
            }
            queryDrugSpu({ search_value: val, first_category:[type] }).then(res => {
                let { code, data } = res
                if (code == 200) {
                    if (_.isEmpty(data)) {
                        this.drugList = []
                        this.$refs[`popover${drugIndex}`][0].doShow()
                    } else {
                        this.drugList = data
                        this.$refs[`customTable${drugIndex}`][0].$refs.customTable.setCurrentRow(this.drugList[this.drugIndex])
                        this.$refs[`popover${drugIndex}`][0].doShow()
                    }
                }
            })
        }, 300),
        /**
           * 
           */
        numberInputMove(e, type, drugIndex) {
            let height = 0;
            let dom = this.$refs[`customTable${drugIndex}`][0].$el.querySelector('.el-table__body-wrapper')
            if (this.drugIndex >= 3) {
                height = 40
            }
            switch (type) {
                case 'up':
                    if (Utils.gt(this.drugIndex, 0)) {
                        this.drugIndex--;
                    }
                    dom.scrollTop = dom.scrollTop - height
                    this.$refs[`customTable${drugIndex}`][0].$refs.customTable.setCurrentRow(this.drugList[this.drugIndex])
                    break;
                case 'down':
                    if (Utils.gt(this.drugList.length - 1, this.drugIndex)) {
                        this.drugIndex++;
                    }
                    dom.scrollTop = dom.scrollTop + height
                    this.$refs[`customTable${drugIndex}`][0].$refs.customTable.setCurrentRow(this.drugList[this.drugIndex])
                    break;
                case 'left':
                    if (this.focusIndex == 1) {
                        this.$refs[`search${drugIndex}`][0].select()
                        this.focusIndex = 0
                    } else if (this.focusIndex == 0) {
                        drugIndex = this.$bigNumber(drugIndex, '-', 1)
                        if (Utils.lt(drugIndex, 0)) return
                        this.$refs[`dosage${drugIndex}`][0].select()
                        this.focusIndex = 1
                    }
                    break;
                case 'right':
                    if (this.focusIndex == 0) {
                        this.$refs[`dosage${drugIndex}`][0].select()
                        this.focusIndex = 1
                    } else if (this.focusIndex = 1) {
                        this.searchFocus(drugIndex)
                        this.focusIndex = 0
                    }
                    break;
            }
        },
        setDrug(val, drugIndex) {
            if (isNull(this.drugList[this.drugIndex])) return;
            if (Utils.gt(this.drugIndex, -1)) {
                let row = deepClone(this.drugList[this.drugIndex])
                this.rowClick(row, drugIndex)
            } else {
                this.$refs[`dosage${drugIndex}`][0].focus()
            }
        },
        /**
         * 点击药品表格
         * index 处方索引
         * @param {*} row 
         */
        rowClick(row, drugIndex) {
            let obj = deepClone(this.editRecipeForm.items[drugIndex])
            obj = {
                ...obj, drugName: row.spuCommonName, handling: obj.handling,
                number: null, unit: row.unit, price: row.price, oldDrugName: row.spuCommonName,spuId:row.spuId
            }
            let flag = false
            let items = this.editRecipeForm.items
            let length = items.length
            items.forEach(item => {
                if (item.spuId == row.spuId) {
                    this.$message.error('该处方已添加过该药品！')
                    flag = true
                }
            })
            if (flag) return
            items[drugIndex] = obj
            if (length == 1 || drugIndex == length - 1) {
                this.addSearch(items)
            }
            this.editRecipeForm.items = items
            this.$refs[`popover${drugIndex}`][0].doClose()
            this.drugList = []
            this.$nextTick(() => {
                this.$refs[`dosage${drugIndex}`][0].focus()
            })
            this.drugIndex = -1
        },
        /**
         * 输入药品用量
         */
        formatNum: _.debounce(function (e, kid) {
            if (isNull(e)) return;
            let temp = e.toString();
            temp = temp.replace(/。/g, ".");
            temp = temp.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
            temp = temp.replace(/^\./g, ""); //验证第一个字符是数字
            temp = temp.replace(/\.{2,}/g, ""); //只保留第一个, 清除多余的
            temp = temp.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
            temp = temp.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
            kid.number = temp;
            this.$forceUpdate()
        }, 500),
        /**
        *  用量输入框聚焦 
        */
        dosageFocus(drugIndex) {
            this.focusIndex = 1;
            this.$refs[`popover${drugIndex}`][0].doClose()
        },
        /**
        * 药品搜索框聚焦
        */
        searchFocus(drugIndex) {
            drugIndex = this.$bigNumber(drugIndex, '+', 1)
            if (Utils.eq(drugIndex, this.editRecipeForm.items.length)) return;
            this.$refs[`search${drugIndex}`][0].focus()
        },
        /**
         * 选择药品煎法
         * index 处方索引
         * drugIndex 药品索引
         */
        chooseUsage(val, drugIndex) {
            let items = deepClone(this.editRecipeForm.items)
            items[drugIndex].handling = val
            this.editRecipeForm.items = items
            this.$refs[`usagePopover${drugIndex}`][0].doClose()
        },
        /**
        * 删除药品
        * drugIndex 药品索引
        */
        removeDrug(drugIndex) {
            this.editRecipeForm.items.splice(drugIndex, 1)
        },
        /**
       * 添加空白搜索框
       * drugList
       */
        addSearch(items) {
            items.push({
                spuId: '',
                drugName: '',
                number: '',
                unit: 'g',
                deleteShow: false,//是否显示删除icon
                handling: '',
            })
        },
        doseNumChange: _.debounce(function () {
            if (!this.editRecipeForm.quantity) {
                this.editRecipeForm.quantity = '1'
            }
            this.editRecipeForm.quantity = this.editRecipeForm.quantity.replace(/^(0+)|[^\d]+/g, '')
        }, 1000),
        //验证必填项
        validateInput() {
            if (isNull(this.editRecipeForm.comboName)) {
                this.isInputInvalid = true
            } else {
                this.isInputInvalid = false
            }
        },
        /**
         * 保存
         */
        comboSave() {
            let numberFlag = false;
            if (isNull(this.editRecipeForm.processFee)) return this.$message.error('请输入加工费')
            if (isNull(this.editRecipeForm.doctorId)) return this.$message.error('请选择归属')
            this.validateInput()
            if (this.isInputInvalid) { return this.$message.error('请输入名称') }
            this.editRecipeForm.items.forEach((item, index) => {
                if (isNull(item.spuId)) this.editRecipeForm.items.splice(index, 1)
            })
            if (this.editRecipeForm.items.length == 0) {
                this.$message('您未选择药材，请选择后再试！');
                this.addSearch(this.editRecipeForm.items)
                return;
            }
            numberFlag = this.editRecipeForm.items.some(item => { return isNull(item.number) || Utils.le(item.number, 0) })
            if (numberFlag) {
                this.$message.error('商品数量不能为空或小于0');
                this.addSearch(this.editRecipeForm.items)
                return;
            }
            if (this.comboTypeAction == 'add') {
                comboDTO.addComboDTO(this.editRecipeForm).then(res => {
                    let { code, data } = res;
                    if (code == 200) {
                        this.$message.success("新增医联产品成功！");
                    } else {
                        this.addSearch(this.editRecipeForm.items)
                    }
                    this.$emit('saveSuceess', data)
                }).catch(() => {
                    this.addSearch(this.editRecipeForm.items)
                })
            } else if (this.comboTypeAction == 'edit') {
                comboDTO.editComboAndItemDTO(this.editRecipeForm).then(res => {
                    let { code, data } = res;
                    if (code == 200) {
                        this.$message.success("修改处方模板成功！");
                    } else {
                        this.addSearch(this.editRecipeForm.items)
                    }
                    this.$emit('saveSuceess', data)
                }).catch(() => {
                    this.addSearch(this.editRecipeForm.items)
                })
            }
        },
        nameChange(list, type) {
            if (type == 1) {
                return list.map(kid => {
                    return {
                        deleteShow: false,
                        drugName: kid.drugName,
                        number: kid.number,
                        handling: kid.handling,
                        oldDrugName: kid.drugName,
                        unit: kid.unit,
                        price: kid.price,
                    }
                })
            }
            if (type == 2) {
                return list.map(kid => {
                    return {
                        drugName: kid.drugName,
                        number: kid.number,
                        unit: kid.unit,
                        handling: kid.handling,
                    }
                })
            }

        },
        /**
         * 加工费改变
         */
        processFeeChange: debounce(function (val) {
            let bol = validParams(val, positiveNum, '请输入数字,保留两位小数,长度不能超过6位')
            if (!bol) {
                this.editRecipeForm.processFee = ''
            }
        }, 300),
        // 煎法获取焦点
        async decoctionFocus(item) {
            const oftenDecoction = await Outpatient.getOftenDecoction(item.spuId)
            if (oftenDecoction) {
                this.$set(item, 'rememberDecoction', true)
            } else {
                this.$set(item, 'rememberDecoction', false)
            }
        },
        // 记住煎法
        rememberDecoction(item) {
            let rememberDecoction = true
            let enable = 1
            if (item['rememberDecoction'] === true) {
                rememberDecoction = false
                enable = 0
            }
            this.$set(item, 'rememberDecoction', rememberDecoction)
            if (![null, undefined, ''].includes(item.handling)) {
                Outpatient.saveOftenDecoction(item.spuId, item.handling, enable)
            }
        },
        // 匹配常用用法
        matchOftenUsageList(key = '煎服', item) {
            let matchKey = key
            const obj = JSON.parse(JSON.stringify(item))

            doseCanChooseKeys.forEach(key => {
                obj[key] = ''
            })

            if (this.doseCanChoose.findIndex(v => v.name === matchKey) === -1) {
                matchKey = '煎服'
            }
            let defaultOftenUsageOption = this.doseCanChoose.find(v => v.name === matchKey) || { label: [] }
            defaultOftenUsageOption.label.map((v) => {
                obj[v.id] = v.default
            })

            const defaultOftenUsageKeys = defaultOftenUsageOption.label.map(v => v.id)

            const remoteOftenUsageOption = this.drugOftenUsageList.find(v => v.recipeMethod === key)
            if (remoteOftenUsageOption) {
                Object.keys(remoteOftenUsageOption).map(k => {
                    if (defaultOftenUsageKeys.includes(k)) {
                        obj[k] = remoteOftenUsageOption[k]
                    }
                })
            }

            return obj
        },
        //是否自备
        handleIsOwned(kid) {
            if (isNull(kid.isOwned) || kid.isOwned == '0') {
                kid.isOwned = '1'
            } else if (!isNull(kid.isOwned) && kid.isOwned == '1') {
                kid.isOwned = '0'
            }
        }

    },
}
</script>

<style lang="less" scoped src="./addComboDialog.less"></style>
<style lang="less">
.usage-popper {
    padding: 0;

    .usage-list {
        background: #FFFFFF;
        box-shadow: 0px 4px 8px 0px rgba(183, 183, 183, 0.25);
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #E1E1E1;

        .usage-item {
            padding: 8px 10px;
            font-size: 15px;
            color: #333;
            cursor: pointer;

            &:hover {
                background: #D4E4FF;
            }
        }
    }

}</style>